// ========================================
// CUSTOM QUOTE CART
// ========================================

// GET CART
function getQuoteCart(){

  return JSON.parse(
    localStorage.getItem("quoteCart")
  ) || [];

}

// SAVE CART
function saveQuoteCart(cart){

  localStorage.setItem(
    "quoteCart",
    JSON.stringify(cart)
  );

}

// ADD ITEM
function addToQuoteCart(item){

  let cart = getQuoteCart();

  cart.push(item);

  saveQuoteCart(cart);

  console.log(cart);

}

// ========================================
// CLICK EVENT
// ========================================

document.addEventListener("click", function(e){

  const btn =
    e.target.closest(".custom-add-to-quote");

  if(!btn) return;

  // product card
  const card =
    btn.closest(".product-card");

  // selected tier
  const selected =
    card.querySelector(".bulk-radio:checked");

  if(!selected){
    alert("Please select tier");
    return;
  }

  // GET DATA
  const title =
    card.dataset.title;

  const image =
    card.dataset.image;

  const variant =
    card.dataset.variant;

  const qty =
    parseInt(selected.dataset.qty);

  const price =
    parseFloat(selected.dataset.price);

  const unit =
    selected.dataset.unit;

  // TOTAL
  const total =
    qty * price;

  // CREATE ITEM
  const item = {

    title,
    image,
    variant,
    qty,
    price,
    unit,
    total

  };

  // ADD TO CART
  addToQuoteCart(item);

  alert("Added to quote");

});